import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideBarComponent } from './side-bar/side-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { BaseLayoutComponent } from './base-layout/base-layout.component';
import { SettingsLayoutComponent } from './settings-layout/settings-layout.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';

import { UserAccountComponent } from './side-bar/user-account/user-account.component';
import { SidebarmenuComponent } from './side-bar/sidebarmenu/sidebarmenu.component';
import { NbLayoutModule, NbCardModule, NbIconModule, NbTooltipModule, NbListModule, NbButtonModule, NbPopoverModule, NbMenuModule, NbContextMenuModule, NbTabsetModule, NbToggleModule } from '@nebular/theme';
import { MatIconModule } from '@angular/material/icon';
import { AgentDisplayComponent } from './side-bar/agent-display/agent-display.component';
// Standalone components needed by layout
import { MessageMultiTabsComponent } from 'src/app/shared/components/message-multi-tabs/message-multi-tabs.component';
import { ModalChatComponent } from './side-bar/modal-chat/modal-chat.component';


@NgModule({
    declarations: [
        SideBarComponent,
        BaseLayoutComponent,
        SettingsLayoutComponent,
        AuthLayoutComponent,
        UserAccountComponent,
				AgentDisplayComponent,
        SidebarmenuComponent,
				HomeLayoutComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        MessageMultiTabsComponent,
        ModalChatComponent,
        MatIconModule,
				NbLayoutModule,
				NbCardModule,
				NbTabsetModule,
				NbIconModule,
				NbTooltipModule,
				NbListModule,
				NbButtonModule,
				NbToggleModule,
				NbPopoverModule,
				NbMenuModule.forRoot(),
				NbContextMenuModule
    ],
    exports: [
        SideBarComponent,
				HomeLayoutComponent
    ]
})
export class LayoutModule { }
